import React from "react";
import styles from "./CategoryHelper.module.css";

const CategoryHelper = (props) => {
  let catStrings = [];
  let splitVals = props?.Event?.BP_Categories?.split(";");
  if (splitVals) {
    splitVals.forEach((catid) => {
      let cat = props?.Categories?.find((x) => x.CategoryID === Number(catid));
      if (cat?.CategoryDisplayName !== "Events" && cat?.CategoryDisplayName !== "View All") {
        catStrings.push(cat?.CategoryDisplayName);
      }
    });
  }

  return catStrings.map((catString, i) => {
    return (
      <span className={styles.eventCategoryPill} key={i}>
        {catString}
      </span>
    );
  });
};

export default CategoryHelper;
